// extracted by mini-css-extract-plugin
export var _card = "card-module--_card--sc2Nr";
export var _cardService = "card-module--_cardService--38GvO";
export var details = "card-module--details--2nLNL";
export var _cardFooter = "card-module--_cardFooter--2bvuu";